import React from "react";

import { IgChip, ShopifyColor, StripeColor } from "@intelligems/ig-theme";
import { Chip, Grid } from "@mui/material";

const labelConfig = {
  both: {
    color: undefined,
    label: (
      <Grid
        container
        item
        sx={{ width: "40px" }}
        justifyContent={"space-between"}
      >
        <Grid item>S</Grid>
        <Grid item>S</Grid>
      </Grid>
    ),
    background: "linear-gradient(-45deg, #6058F7 50%, #91B944 50%)",
  },
  stripe: {
    color: StripeColor,
    label: "Stripe",
    background: undefined,
  },
  shopify: {
    color: ShopifyColor,
    label: "Shopify",
    background: undefined,
  },
};

interface BillingServiceBadgeProps {
  service: "shopify" | "stripe" | "both";
  deprecated?: boolean;
}

export const BillingServiceBadge = ({
  service,
  deprecated,
}: BillingServiceBadgeProps) => {
  return (
    <IgChip
      label={labelConfig[service].label}
      size={"small"}
      sx={{
        borderRadius: "4px",
        backgroundColor: labelConfig[service].color,
        background: labelConfig[service].background,
        color: "white",
        width: "65px",
        // border: deprecated ? "solid #F58B3B 2px" : undefined,
      }}
    />
  );
};
